import React from 'react';
export function Eyebrow({
  children,
  danger = false
}: {
  children: React.ReactNode;
  danger?: boolean;
}) {
  return <p className={`mb-3 text-center text-[11px] font-bold uppercase tracking-[.16em] md:text-sm ${danger ? 'text-red-400' : 'text-gold'}`} data-id="element-347" data-mp="10zr1oaza8wi0">
      {children}
    </p>;
}
export function SectionTitle({
  children
}: {
  children: React.ReactNode;
}) {
  return <h2 className="mx-auto max-w-3xl text-center text-2xl font-black leading-tight text-white md:text-4xl" data-id="element-348" data-mp="mzq2czyo1x4n">
      {children}
    </h2>;
}